import React from "react";

interface ConfirmRecurrentAlertProps {
  setConfirmShow: React.Dispatch<React.SetStateAction<boolean>>;
  onClick: (isRecurrent: boolean) => void;
  msg: string;
  pId?: number;
  rId?: number;
  setIsRecurrent: React.Dispatch<React.SetStateAction<boolean>>;
  isRecurrent: boolean;
}

const ConfirmRecurrentAlert: React.FC<ConfirmRecurrentAlertProps> = ({
  setConfirmShow,
  onClick,
  msg,
  pId,
  rId,
  setIsRecurrent,
  isRecurrent,
}) => {
  return (
    <div className="alertView">
      <div>
        <div className="title">Confirm</div>
        <div className="mainText">
          <div className="message">{msg}</div>
        </div>
        {rId && (
          <>
            <div className="switch-button mx-auto mt-4">
              <input
                className="switch-button-checkbox"
                type="checkbox"
                checked={isRecurrent}
                onChange={(e) => setIsRecurrent(e.target.checked)}
              />
              <label className="switch-button-label white">
                <span className="switch-button-label-span">One Time</span>
              </label>
            </div>
            <br />
          </>
        )}

        <div className="actionButton">
          <button
            className="blue p-1 pl-3 pr-3 mr-2"
            onClick={() => setConfirmShow(false)}
          >
            No
          </button>
          <button
            className="blue p-1 pl-3 pr-3"
            onClick={() => {
              onClick(isRecurrent);
              setConfirmShow(false);
            }}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmRecurrentAlert;
